<template>
  <div v-if="productLoaded && isProductLoaded">
    <ErrorPane v-if="!currentDemo" :errorText="'Erreur 404 : cette démo n\'existe pas'"></ErrorPane>
    <div v-if="currentDemo" :class="{ appcontainer: true, fullScreen: isFullscreen }">
      <transition mode="out-in">
        <router-view />
      </transition>
    </div>
    <AppMenu v-if="currentDemo">
      <template v-slot:topextremeleft v-if="!isFullscreen">
        <RoundButton class="homeButton" href="/" width="60" image="ic-home.svg" v-if="$route.query.embed !== 'true'" />
      </template>
      <template v-slot:topleft v-if="!isFullscreen">
        <div class="formfield-select">
          <div>
            <RoundButton
              class="bordered back"
              :href="backToConfigurator"
              :width="currentScreenWidth > 1024 ? 35 : 25"
              image="ic-arrow-back.svg"
            />
          </div>
          <div class="formfield-select--container">
            <DemoSelect :options="allDemos" v-model="selectedDemo" />
          </div>
        </div>
      </template>
      <template v-slot:topextremeright>
        <RoundButton
          v-if="!isFullscreen"
          v-on:go="knowMore"
          text="Informations"
          width="51"
          textClass="textHelp"
          class="helpButton"
          image="ic-info.svg"
        />
        <RoundButton
          v-if="isFullscreen"
          class="bordered close-fullscreen"
          v-on:go="exitFullscreen"
          width="35"
          image="ic-close.svg"
        />
      </template>

      <template v-slot:centerleft v-if="!isFullscreen">
        <!--OPTIONS Compare mode -->
        <!-- v-if="isPhotoCompareMode" -->
        <RoundButton
          v-on:go="compareMode"
          v-if="isActionEnabled('compare')"
          width="35"
          image="ic-compare.svg"
          class="leftMenuButton bordered"
          :color="isCompareMode ? 'white' : ''"
          v-bind:class="{ active: isCompareMode }"
        />
        <label v-if="isActionEnabled('compare')" class="situation-label">{{
          getWebcontrol('Demonstration-Texte-BtnComparaison')
        }}</label>

        <!--OPTIONS Show/hide Blur -->
        <RoundButton
          v-on:go="visibility"
          v-if="isActionEnabled('zone')"
          :width="currentScreenWidth > 1280 ? 35 : 25"
          image="ic-mode-visibility.svg"
          class="leftMenuButton bordered"
          :color="showDashes ? 'white' : ''"
          v-bind:class="{ active: showDashes }"
        />
        <label v-if="isActionEnabled('zone')" class="situation-label">
          {{ getWebcontrol('Demonstration-Texte-BtnAbberations') }}
        </label>

        <!--OPTIONS Esthetique -->
        <RoundButton
          v-if="isActionEnabled('esthetique')"
          :width="currentScreenWidth > 1280 ? 35 : 25"
          image="ic-esthetique.svg"
          class="leftMenuButton bordered"
          @go="switchDemo(getThDemo(1))"
          :color="isPhotoCompareMode ? 'white' : ''"
          v-bind:class="{ active: isPhotoCompareMode }"
        />
        <label v-if="isActionEnabled('esthetique')" class="situation-label">
          {{ getWebcontrol('Demonstration-Texte-BtnFace') }}
        </label>

        <!--OPTIONS Benef -->
        <RoundButton
          v-if="isActionEnabled('benef')"
          @go="switchDemo(getThDemo(0))"
          :width="currentScreenWidth > 1280 ? 35 : 25"
          image="ic-benef.svg"
          class="leftMenuButton bordered"
          :color="isSliderCompare ? 'white' : ''"
          v-bind:class="{ active: isSliderCompare }"
        />
        <label v-if="isActionEnabled('benef')" class="situation-label">
          {{ getWebcontrol('Demonstration-Texte-BtnRefletsDemo') }}
        </label>

        <!--OPTIONS Draw mode -->
        <!-- <RoundButton
          v-if="is360MoreOptions"
          v-on:go="edit"
          width="35"
          image="ic-mode-edit.svg"
          class="leftMenuButton bordered"
        />-->

        <!--OPTIONS Fullscreen -->
        <!-- <RoundButton
          v-if="isVideo || isVideoSlider || isVideoBlur || isOnOff"
          v-on:go="fullscreen"
          width="35"
          image="ic-mode-fullscreen.svg"
          class="leftMenuButton bordered"
        />-->

        <!--OPTIONS Refresh -->
        <RoundButton
          v-if="isActionEnabled('refresh')"
          v-on:go="refresh"
          :width="currentScreenWidth > 1280 ? 35 : 25"
          image="ic-mode-autorenew.svg"
          class="leftMenuButton bordered"
        />
        <label v-if="isActionEnabled('refresh')" class="situation-label">
          {{ getWebcontrol('Demonstration-Texte-BtnReinitialiser') }}
        </label>
      </template>

      <!--Situations -->
      <template v-slot:centerright v-if="!isFullscreen && currentDemo.situations && !this.isPhotoCompareMode">
        <div class="sliderPhoto" v-bind:key="situation.id" v-for="situation in currentDemo.situations">
          <RoundButton
            :width="currentScreenWidth > 1280 ? 35 : 25"
            :href="changeSituation(situation.id)"
            :image="`ic-${situation.name}.svg`"
            class="rightMenuButton bordered"
            :color="situation.id == $route.params.idSituation ? 'white' : 'grey'"
            v-bind:class="{ active: situation.id == $route.params.idSituation }"
          />
          <label class="situation-label">{{ getWebcontrol(situation.path) }}</label>
          <div class="luminositySelector" v-if="isPhoto && situation.id == $route.params.idSituation">
            <input type="range" v-on:input="opacityChange" min="30" max="65" value="50" orient="vertical" />
          </div>
        </div>
      </template>
      <template v-slot:bottomleft v-if="!isFullscreen">
        <Modal
          :title="infoCurrentProd.name"
          :content="infoCurrentProd.description"
          v-if="showModal"
          v-on:close="showModal = false"
        />
      </template>
      <template v-slot:bottomcenter>
        <!--SELECTOR DEMO PHOTO TINTS-->
        <div class="blurSelector" v-if="isPhoto">
          <GlassesTintsSelect id="glassesTintsSelect" :options="photoGlasses" />
        </div>

        <!--SELECTOR DEMO VIDEO TINTS-->
        <div class="blurSelector" v-if="isVideoSlider">
          <TintsSelect id="color_select" :options="photoGlasses" />
        </div>

        <div class="select-video" v-if="isVideoCompare">
          <VideoSelect
            v-on:input="switchDemo($event['demos'][0]['id'])"
            :options="glasses"
            :value="currentModel"
            :label="'Sélectionner'"
          />
          <span class="select-video-compared">
            <h4>Comparé à</h4>
            <span class="select-video-name">Verre unifocal standard</span>
          </span>
        </div>

        <div v-if="isSliderCompare || isPhotoCompareMode" class="select-video">
          <VideoSelect
            :value="LeftSelectedValue || currentModel"
            :options="getCompareSlideValue(true)"
            @input="updateLeftGlasses($event)"
            label="Sélectionner"
          />

          <VideoSelect
            class="select-video-compared"
            :options="getCompareSlideValue(isCompareStairs)"
            @input="updateRightGlasses($event)"
            :value="RightSelectedValue || { name: 'Traitement standard', id: 'Verre sans traitement' }"
            label="Comparer à"
          />
        </div>

        <div v-if="isTransitions" class="select-video">
          <VideoSelect
            :value="LeftSelectedValue || currentModel"
            :options="getCompareSlideValue(true)"
            @input="updateLeftGlasses($event)"
            label="Sélectionner"
          />
          <ColorTintsSelect
            :value="listColorsTransitions[transitionColor]"
            :options="listColorsTransitions"
            @input="transitionColor = $event"
          />
        </div>

        <!--SELECTOR DEMO VIDEO BLUR-->
        <div class="blurSelector" v-if="isVideoBlur || is360MoreOptions || isCompareStairs">
          <GlassesSelect
            :style="styleObject"
            id="blur_glasses"
            :initLeftGlasses="LeftSelectedValue"
            :initRightGlasses="RightSelectedValue"
            :options="glasses"
            @rightGlasses="updateRightGlasses"
            @leftGlasses="updateLeftGlasses"
          />
        </div>
        <div class="blurSelector" v-if="isOnOff">
          <OnOffButton @valueCheck="checked" image="eye-protect-system-black.svg" text="Verre sans protection" />
        </div>
      </template>
      <template v-slot:bottomrightincontainer>
        <img class="logo-bottom-right" src="../../assets/logo.png" />
      </template>
    </AppMenu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AppMenu from '@Components/Menu';
import RoundButton from '@Components/Menus/RoundButton';
import DemoSelect from '@Components/Menus/DemoSelect';
import GlassesSelect from '@Components/Menus/videoBlur/GlassesSelect';
import TintsSelect from '@Components/Menus/videoSlider/TintsSelect';
import GlassesTintsSelect from '@Components/Menus/photo/GlassesTintsSelect';
import OnOffButton from '@Components/Menus/photo/OnOffButton';
import Modal from '@Components/Modal';
import ErrorPane from '@Components/Error/ErrorPane';
import { onWindowResize } from '../../components/Demos/360/scripts/scriptBabylon';
import VideoSelect from '../../components/Menus/videoCompare/VideoSelect';
import config from '../../settings/configEssilor';
import ColorTintsSelect from '../../components/Menus/photo/ColorTintsSelect';

export default {
  components: {
    ColorTintsSelect,
    AppMenu,
    RoundButton,
    GlassesTintsSelect,
    TintsSelect,
    GlassesSelect,
    DemoSelect,
    Modal,
    VideoSelect,
    OnOffButton,
    ErrorPane,
  },
  data() {
    return {
      RightSelectedValue: '',
      LeftSelectedValue: '',
      onOff: true,
      blurActive: true,
      selectedDemo: '',
      demos: [],
      allDemos: null,
      opacity: 1,
      showModal: false,
      isFullscreen: false,
      unwatchers: [],
      refreshInfo: 1,
      transitionColor: 0,
      listColorsTransitions: [],
    };
  },
  watch: {
    $route() {
      this.initDemo();
    },
    selectedDemo: function(demo) {
      this.$router.push(this.keepQueryParams(demo.href)).catch(err => {
        this.$log.error(err);
      });
    },
    productLoaded() {
      this.initDemo();
    },
  },
  created() {
    this.initDemo();
  },
  mounted() {
    this.$log.debug('this.$store.getters.getProductSelected', this.$store.getters.products);
    // if (!this.$store.getters.getProductSelected) {
    // this.unwatchers.push(
    //   this.$store.watch(
    //     (state, getters) => getters.products,
    //     newValue => {
    //       this.$log.debug('products', newValue);
    //       this.allDemos = this.getAllDemos();
    //     }
    //   )
    // );
    // this.$store.dispatch('loadProducts');
    // }
    this.allDemos = this.getAllDemos;
  },
  destroyed() {
    // Remove all watchers
    let unwatchMethod;
    while (this.unwatchers.length > 0) {
      // Get the "unwatch" methods...
      unwatchMethod = this.unwatchers.pop();
      // ... and call it!
      unwatchMethod();
    }
  },

  computed: {
    ...mapGetters(['isCompareMode', 'showDashes']),
    configTransitions() {
      return config['configTransition'];
    },
    isProductLoaded() {
      return this.$store.getters.isProductsLoaded();
    },
    backToConfigurator() {
      return this.keepQueryParams(
        this.$route.query.origin === 'decouvrirProduit' ? '/products' : '/demos/configurator/'
      );
    },
    productLoaded() {
      return this.$store.getters.isProductsLoaded();
    },
    getAllDemos() {
      const options = [];
      if (this.$store.getters.isProductsLoaded()) {
        // let idProduct = this.$store.getters.getProductByDemoId(this.$route.params.id).id;
        // const demos = this.$store.getters.demosByProduct(idProduct).filter(demo => demo.isActive);
        // //const selectedProduct = this.$store.getters.getProductByDemoId(this.$route.params.id);
        const selectedProducts = this.$store.getters.getProductSelected;
        Object.keys(selectedProducts).forEach(key => {
          if (selectedProducts[key]) {
            this.$store.getters.demosByProduct(selectedProducts[key]).forEach(demo =>
              // demos.forEach(demo =>
              options.push({
                category: key.toUpperCase(),
                name: demo.name.toUpperCase(),
                href: this.$store.getters.getDemoLink(demo.id),
                selected: demo.id == this.$route.params.id,
              })
            );
          }
        });

        if (options.length === 0) {
          const selectedProduct = this.$store.getters.getProductByDemoId(this.$route.params.id);
          if (selectedProduct) {
            options.push({
              category: selectedProduct.category.toUpperCase(),
              name: this.currentSituation.name.toUpperCase(),
              href: this.$store.getters.getDemoLink(this.currentSituation.demoId),
              selected: this.currentSituation.demoId == this.$route.params.id,
            });
          }
        }
      }
      return options;
    },
    infoCurrentProd() {
      if (
        (this.isSliderCompare || this.isPhotoCompareMode || this.isVideoBlur || this.is360MoreOptions) &&
        this.refreshInfo
      ) {
        return this.$store.getters.getProductById(JSON.parse(window.localStorage.getItem('crizal_left')).id);
      }
      return this.$store.getters.getProductById(this.currentDemo.productId);
    },
    currentScreenWidth() {
      return window.outerWidth;
    },
    //get current situation
    currentSituation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
    currentModel() {
      return this.$store.getters.getProductByDemoId(this.currentDemo.id);
    },
    //get current demo
    currentDemo() {
      return this.$store.getters.getDemoById(this.$route.params.id);
    },
    //check if current situatution type is 360
    is360() {
      return this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === '360';
    },
    //check if current situatution type is photo
    isPhoto() {
      return this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'photo';
    },
    isTransitions() {
      return this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'transitions';
    },
    //check if current situatution is video
    isVideo() {
      if (
        !this.$route.params.idSituation ||
        (this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'video')
      ) {
        return true;
      }
      return false;
    },
    //check if current situation is a video with other videos selectables to compare
    isVideoCompare() {
      return (
        !this.$route.params.idSituation ||
        (this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'videoCompare')
      );
    },
    //check if current situatution is video with blur
    isVideoBlur() {
      return this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'videoBlur';
    },
    //check if current situatution is video with luminosity slider
    isVideoSlider() {
      return this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'videoSlider';
    },
    // check if current situation is 360 and more options
    is360MoreOptions() {
      // TODO Do not use hard-coded IDs use when api activated (boolean: fullscreen, dessin, affichage des zones, raz)
      // if (
      //   this.currentSituation.id == "14" ||
      //   this.currentSituation.id == "15"
      // ) {
      //   return true;
      // }
      // return false;
      return this.is360;
    },

    isPhotoCompareMode() {
      return (
        this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'PhotoCompareMode'
      );
    },

    isSliderCompare() {
      return (
        this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'CompareSlider'
      );
    },

    isCompareStairs() {
      return (
        this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'compareStairs'
      );
    },

    // Return the list of glasses for photo tints demo

    isOnOff() {
      return this.currentSituation && (this.currentSituation.id == 15 || this.currentSituation.id == 16);
    },

    glasses() {
      return this.$store.getters.getComparisonProducts(this.$route.params.id);
    },
    photoGlasses() {
      return this.$store.getters.getTransitionsForTintsDemo();
    },
    styleObject: function() {
      return {
        '--justifyContent': this.is360 && this.isCompareMode ? 'space-evenly' : 'space-around',
      };
    },

    // Return the list of the other demo for the selected product
  },
  methods: {
    getListColorsTransitions() {
      return this.listColorsTransitions;
    },
    keepQueryParams(url) {
      let newUrl = url;
      if (this.$route.query.embed === 'true') {
        newUrl += (newUrl.indexOf('?') > 0 ? '&' : '?') + 'embed=true';
      }
      if (this.$route.query.optimize || this.$route.query.correct || this.$route.query.protect) {
        newUrl +=
          (newUrl.indexOf('?') > 0 ? '&' : '?') +
          'optimize=' +
          this.$route.query.optimize +
          '&correct=' +
          this.$route.query.correct +
          '&protect=' +
          this.$route.query.protect;
      }
      if (this.$route.query.origin) {
        newUrl += (newUrl.indexOf('?') > 0 ? '&' : '?') + '&origin=' + this.$route.query.origin;
      }
      return newUrl;
    },
    changeSituation(id) {
      return this.keepQueryParams(this.$store.getters.getSituationLink(id));
    },
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
    getCompareSlideValue(isFirstSide) {
      let ret = [];
      if (!this.isCompareMode && !this.isSliderCompare && !this.isPhotoCompareMode) {
        return this.glasses;
      }
      if (isFirstSide) {
        ret = this.glasses;
        return ret.filter(elem => elem.id !== this.RightSelectedValue.id);
      }

      ret = ret.concat(this.glasses);
      ret.push({ name: 'Traitement standard', id: 'Verre sans traitement' });
      return ret.filter(elem => elem.id !== this.LeftSelectedValue.id);
    },
    initDemo() {
      this.$gtag.pageview({
        page_title: `Démo ${this.currentModel.name} ${this.currentDemo.name} ${this.currentSituation.name}${
          this.$route.query.embed === 'true' ? ' embarqué' : ''
        }`,
        page_path: `/Démo ${this.currentModel.name} ${this.currentDemo.name} ${this.currentSituation.name}${
          this.$route.query.embed === 'true' ? ' embarqué' : ''
        }`,
        page_location: window.location.href,
      });
      //Compare mode for Varilux E Series
      if (this.glasses) {
        const selectedProduct = this.$store.getters.getProductByDemoId(this.$route.params.id);

        let savedRightGlasses = window.localStorage.getItem('crizal_right');

        if (savedRightGlasses) {
          savedRightGlasses = JSON.parse(savedRightGlasses);
        }
        if (savedRightGlasses && !this.getCompareSlideValue(false).some(value => savedRightGlasses.id === value.id)) {
          savedRightGlasses = null;
        }
        this.updateRightGlasses(
          this.isCompareStairs
            ? { name: 'Traitement standard', id: 'PROG-STANDARD' }
            : savedRightGlasses || { name: 'Traitement standard', id: 'Verre sans traitement' }
        );
        let savedLeftGlasses = window.localStorage.getItem('crizal_left');
        if (savedLeftGlasses) {
          savedLeftGlasses = JSON.parse(savedLeftGlasses);
        }

        if (savedLeftGlasses && !this.getCompareSlideValue(true).some(value => savedLeftGlasses.id === value.id)) {
          savedLeftGlasses = null;
        }
        this.updateLeftGlasses(
          savedLeftGlasses ||
            (!selectedProduct
              ? this.glasses[0]
              : this.glasses.find(glass => {
                  return glass.id === selectedProduct.id;
                }))
        );
      }
      //Compare mode for Crizal Sapphire+ plus and situation is facies
      // if (this.isPhotoCompareMode || this.isSliderCompare) {
      //   this.updateRightGlasses({ name: 'Traitement standard', id: 'Verre sans traitement' });
      //   this.updateLeftGlasses(this.currentModel);
      // }
    },
    isActionEnabled(actionType) {
      return this.currentSituation && this.currentSituation.type && this.currentSituation.type.indexOf(actionType) >= 0;
    },
    switchDemo(demoId) {
      const product = this.$store.getters.getProductByDemoId(demoId);
      this.$store.commit('selectProduct', { category: product.category, productId: product.id });
      if (this.$route.path !== this.$store.getters.getDemoLink(demoId))
        this.$router.push(this.keepQueryParams(this.$store.getters.getDemoLink(demoId))).catch(err => {
          this.$log.error(err);
        });
    },
    getThDemo(index) {
      return this.$store.getters.demosByProduct(this.currentDemo.productId)[index]['id'];
    },
    updateLeftGlasses(leftGlasses) {
      this.LeftSelectedValue = leftGlasses;
      if (this.isTransitions) {
        this.listColorsTransitions = this.configTransitions[leftGlasses.id];
        if (!this.listColorsTransitions[this.transitionColor]) {
          this.transitionColor = 0;
        }
      }
      if (leftGlasses.name === 'Verre progressif standard') {
        this.showModal = false;
      } else {
        this.refreshInfo = this.refreshInfo * -1;
      }
      window.localStorage.setItem('crizal_left', JSON.stringify(leftGlasses));
    },
    updateRightGlasses(rightGlasses) {
      this.RightSelectedValue = rightGlasses;
      window.localStorage.setItem('crizal_right', JSON.stringify(rightGlasses));
    },
    // Change the mask opacity (demo photo)
    opacityChange: function(evt) {
      var mask = document.querySelector('.svgMask g');
      mask.style.opacity = evt.target.value / 100;
    },
    checked(e) {
      this.onOff = e;
    },
    //Show/hide the blur (demo video blur)
    compareMode() {
      this.$store.commit('setCompareMode', !this.$store.getters.isCompareMode);
      if (this.$store.getters.isCompareMode) {
        // alert('open Compare')

        const selectedProduct = this.$store.getters.getProductByDemoId(this.$route.params.id);

        let savedRightGlasses = window.localStorage.getItem('crizal_right');
        if (!this.getCompareSlideValue(false).includes(savedRightGlasses)) {
          savedRightGlasses = null;
        }
        if (savedRightGlasses) {
          savedRightGlasses = JSON.parse(savedRightGlasses);
        }

        this.updateRightGlasses(
          savedRightGlasses || selectedProduct.rangeId === 'VARILUX'
            ? {} // will automatically choose the last valid item
            : { name: 'Traitement standard', id: 'Verre sans traitement' }
        );
      }
    },

    //Show/hide the blur (demo video blur)
    visibility() {
      if (this.isVideoBlur) {
        if (this.blurActive) {
          document.querySelector('.video1').style.webkitMaskImage = 'none';
          document.querySelector('.video2').style.webkitMaskImage = 'none';
        } else {
          document.querySelector('.video1').style.webkitMaskImage = null;
          document.querySelector('.video2').style.webkitMaskImage = null;
        }
      }
      if (this.isVideoBlur) {
        if (this.showDashes) {
          document.querySelector('.dashed-left').style.display = 'none';
          document.querySelector('.dashed-right').style.display = 'none';
        } else {
          document.querySelector('.dashed-left').style.display = 'block';
          document.querySelector('.dashed-right').style.display = 'block';
        }
      }
      this.blurActive = !this.blurActive;

      this.$store.commit('setShowDashes', !this.$store.getters.showDashes);
    },

    // TODO DRAW MODE
    edit() {
      this.$log.debug('Edition en cours');
    },

    // Exit fullscreen
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }

      if (this.isVideoSlider || this.isVideoBlur) {
        this.isFullscreen = false;
        //Reset height
        document.querySelectorAll('video').forEach(video => {
          video.style.height = '87vh';
        });
        //Reset the padding style
        document.querySelector('#app').style.padding = null;
      }
      if (this.is360MoreOptions || this.is360) {
        this.isFullscreen = false;

        // Reset size
        onWindowResize();

        document.querySelector('#app').style.padding = null;
      }
    },
    // Enter in fullscreen
    fullscreen() {
      const elem = document.querySelector('#app');
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }

      //VIDEO SLIDER ET VIDEO BLUR
      if (this.isVideoSlider || this.isVideoBlur) {
        this.isFullscreen = true;
        document.querySelectorAll('video').forEach(video => {
          video.style.height = '100vh';
        });
        document.querySelector('#app').style.padding = '0';
        document.querySelector('#app').style.paddingLeft = '0';
        document.querySelector('#app').style.paddingTop = '0';
        document.querySelector('#app').style.paddingBottom = '0';
      }
      //VIDEO CLASSIQUE
      if (this.isVideo) {
        if (document.querySelector('iframe')) {
          document.querySelector('iframe').requestFullscreen();
        } else if (document.querySelector('#video')) {
          document.querySelector('#video').requestFullscreen();
        }
      }
      // 360 fullscreen
      if (this.is360 || this.is360MoreOptions) {
        this.isFullscreen = true;
        // const canvas = document.getElementById('canvas360');
        // canvas.style.width = '100%';
        // canvas.style.height = '100%';
      }

      if (this.isVideoSlider || this.isVideoBlur || this.is360MoreOptions || this.is360) {
        document.querySelector('#app').style.padding = '0';
        document.querySelector('#app').style.paddingLeft = '0';
        document.querySelector('#app').style.paddingTop = '0';
        document.querySelector('#app').style.paddingBottom = '0';
      }
    },
    refresh() {
      window.localStorage.removeItem('crizal_left');
      window.localStorage.removeItem('crizal_right');
      location.reload();
    },
    knowMore() {
      if (this.LeftSelectedValue.name !== 'Verre progressif standard') {
        this.showModal = true;
      }
    },
  },
};
</script>

<style scoped>
.formfield-select {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: AkhandSoft;
}

.fullScreen {
  width: 100%;
}

.formfield-select.color {
  width: 30%;
}

.appcontainer {
  position: absolute;
  top: 11vh;
  bottom: 11vh;
  left: 7vw;
  right: 7vw;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullScreen.appcontainer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.helpButton {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  padding-right: 7vw;
  right: 0px;
  top: 1.5vh;
}

.blurSelector {
  display: flex;
  width: 100%;
}

* {
  font-family: 'AkhandSoft', Helvetica, Arial, sans-serif;
}

.leftMenuButton {
  margin: auto;
}

.leftMenuButton img svg path {
  fill: white !important;
}

.leftMenuButton.active {
  background-color: black;
}

.rightMenuButton:hover {
  border: 1px solid black;
}

.rightMenuButton.active {
  background-color: #0088ec;
}

.leftMenuButton,
.rightMenuButton {
  width: 88px;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 1306px) {
  .leftMenuButton,
  .rightMenuButton {
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .situation-label {
    display: block;
    margin-top: 3px;
    margin-bottom: 14px;
    font-size: 15px;
  }
}

@media screen and (min-width: 1306px) {
  .situation-label {
    display: block;
    margin-top: 3px;
    margin-bottom: 14px;
    font-size: 20px;
  }
}

.leftMenuButton:hover {
  border: 1px solid black;
}

#blur_glasses {
  display: flex;
  width: 100%;
  /*
  justify-content: space-around;
*/
  justify-content: var(--justifyContent);
}

.ligne {
  width: 2px;
  height: 50px;
  border-left: 1px solid rgba(26, 26, 26, 0.15);
  margin: auto;
}

input[type='range'][orient='vertical'] {
  writing-mode: bt-lr; /* IE */
  -webkit-appearance: slider-vertical; /* WebKit */
  width: 8px;
  height: 175px;
  /* padding: 0 5px; */
}

.action {
  white-space: nowrap;
  transform: rotate(-90deg) translateX(30px);
}

.bordered.close-fullscreen {
  background-color: white;
  border-radius: 100px;
  border: 1px grey solid;
}

.leftSelect {
  position: absolute;
  display: inline;
  left: 0px;
}

.rightSelect {
  position: absolute;
  display: inline;
  right: 0px;
}

button {
  border: none;
  background-color: transparent;
}

.select-video-name {
  white-space: nowrap;
  font-size: 18px;
  color: black;
  letter-spacing: 0.5px;
}
.select-video-compared {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.select-video-compared > h4 {
  margin-right: 2%;
  white-space: nowrap;
}
.select-video {
  display: flex;
  width: 100%;
  justify-content: space-around;
}
.select-video > div {
  flex: 1;
  display: flex;
  justify-content: center;
}

.compareSelect {
  position: absolute;
  min-width: 500px;
  width: 50%;
  height: 50%;
}

.back:hover {
  border: 1px solid black;
}
</style>
